import type { Feature, MultiPolygon, Polygon, Position } from "geojson";
import { point } from "@turf/helpers";
import booleanPointInPolygon from "@turf/boolean-point-in-polygon";

/**
 * Check if a point [lng, lat] is inside a polygon or multipolygon (respects holes).
 */
export function isPointInPolygon(coord: Position, poly: Feature<Polygon | MultiPolygon>): boolean {
	return booleanPointInPolygon(point(coord), poly);
}

/**
 * Filter an array of positions to only those inside a polygon.
 */
export function getPointsInPolygon(points: Position[], poly: Feature<Polygon>): Position[] {
	return points.filter((p) => isPointInPolygon(p, poly));
}
